<div class="d-flex justify-content-between align-items-center gap-2">
    <mat-divider class="flex-grow-1"></mat-divider>
    <div class="dividerwithtext-text">{{ text }}</div>
    <mat-divider class="flex-grow-1"></mat-divider>
</div>
